import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'

import { Footer } from '@Components/Footer'
import { Header } from '@Components/Header'
import CouponBar from '@Components/Header/CouponBar'
import { PageViewEvent } from '@Events/PageView'
import { down } from '@Globals/Style/breakpoints'

const Main = styled.main`
  min-height: 700px;

  ${down('phablet')} {
    min-height: 300px;
  }
`

interface OneColumnProps {
  footer?: ReactNode
  header?: ReactNode
}

export const OneColumn: FC<OneColumnProps> = ({ children, footer, header }) => {
  PageViewEvent.setHasNormalHeader(true)
  PageViewEvent.setHasSideBar(false)

  return (
    <>
      {header || <Header />}
      <CouponBar />
      <Main>{children}</Main>
      {footer || <Footer />}
    </>
  )
}
